import { render, staticRenderFns } from "./TopNumbersDashboard.vue?vue&type=template&id=b2460bb4&"
import script from "./TopNumbersDashboard.vue?vue&type=script&lang=js&"
export * from "./TopNumbersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TopNumbersDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports